"use client";

import Image from "next/image";
import { useCallback, useRef, useState } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

import { GenericSection } from "./ui";

interface ITestimonial {
  text: string;
  author: string;
  image?: string;
}

const testimonials: ITestimonial[] = [
  {
    text: "Minha experiência foi excelente. O atendimento foi ótimo e ela se mostrou super atenciosa, elaborou uma dieta totalmente personalizada, sem cortar os alimentos que eu gosto. Conseguiu equilibrar saúde e prazer de forma inteligente, o que tornou muito mais fácil seguir o plano alimentar. A abordagem foi leve, prática e eficiente.",
    author: "Nicholas Ferreira",
  },
  // {
  //   text: "At facilis dignissimos ea repellat adipisci. Lorem ipsum dolor sit amet. Qui nemo autem qui aspernatur velit qui quis iure.",
  //   author: "Maria Silva",
  // },
  // {
  //   text: "Ut facilis dignissimos ea repellat adipisci. Lorem ipsum dolor sit amet. Qui nemo autem qui aspernatur velit qui quis iure.",
  //   author: "João Santos",
  // },
];

export const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const isAnimating = useRef(false);
  const touchStartX = useRef(0);
  const touchEndX = useRef(0);

  const changeTestimonial = useCallback((newIndex: number) => {
    if (isAnimating.current) return;
    isAnimating.current = true;

    setCurrentIndex(newIndex);
    setTimeout(() => {
      isAnimating.current = false;
    }, 300);
  }, []);

  const handleNext = () => {
    changeTestimonial((currentIndex + 1) % testimonials.length);
  };

  const handlePrev = () => {
    changeTestimonial(
      (currentIndex - 1 + testimonials.length) % testimonials.length
    );
  };

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartX.current = e.changedTouches[0].clientX;
  };

  const handleTouchEnd = (e: React.TouchEvent<HTMLDivElement>) => {
    touchEndX.current = e.changedTouches[0].clientX;
    const diff = touchStartX.current - touchEndX.current;

    if (diff > 50) handleNext();
    if (diff < -50) handlePrev();
  };

  return (
    <GenericSection
      id="testimonials"
      heading="Depoimentos"
      subheading="Nossos clientes dizem"
    >
      <div
        className="relative flex items-center justify-center"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <button
          onClick={handlePrev}
          aria-label="Depoimento Anterior"
          className="absolute left-0 p-2 hidden sm:block text-primary hover:bg-primary-light rounded-full transition"
        >
          <FiChevronLeft size={32} />
        </button>

        <div
          className={`text-center mx-8 sm:mx-16 md:mx-36 lg:mx-46 transition-transform duration-300 ${
            isAnimating ? "translate-x-1 sm:translate-x-0" : "translate-x-0"
          }`}
        >
          <p className="text-paragraph text-lg leading-relaxed mb-4">
            {testimonials[currentIndex].text}
          </p>

          {testimonials[currentIndex].image && (
            <div className="flex justify-center mb-4">
              <Image
                src={testimonials[currentIndex].image!}
                alt={`Foto de ${testimonials[currentIndex].author}`}
                width={200}
                height={200}
                className="w-72 h-w-72 rounded-md"
              />
            </div>
          )}

          <p className="font-bold text-secondary">
            {testimonials[currentIndex].author}
          </p>
        </div>

        <button
          onClick={handleNext}
          aria-label="Próximo Depoimento"
          className="absolute right-0 p-2 hidden sm:block text-primary hover:bg-primary-light rounded-full transition"
        >
          <FiChevronRight size={32} />
        </button>
      </div>

      <div className="flex justify-center mt-12 gap-3">
        {testimonials.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentIndex(index)}
            className="relative flex items-center justify-center"
            aria-label={`Ir para o depoimento ${index + 1}`}
          >
            <span className="absolute w-6 h-6 rounded-full"></span>

            <span
              className={`w-3 h-3 rounded-full transition ${
                index === currentIndex ? "bg-primary" : "bg-primary-light"
              }`}
            ></span>
          </button>
        ))}
      </div>
    </GenericSection>
  );
};
